import React from "react";
import Board from "../../../modules/board/board";
import DonationContainer from "./index.css";

export const HistoryData = [
  {
    idx: 1,
    title: "2015년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2016-03-30",
    password: "",
    filename: "2015 연간기부금모금액_활용실적명세서(창조)",
    file: "2015.pdf",
    content:
      "관련법령에 따라 2015년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 2,
    title: "2016년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2017-03-30",
    password: "",
    filename: "2016 연간기부금모금액_활용실적명세서(창조)",
    file: "2016.pdf",
    content:
      "관련법령에 따라 2016년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 3,
    title: "2017년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2018-01-30",
    password: "",
    filename: "2017 연간기부금모금액_활용실적명세서(창조)",
    file: "2017.pdf",
    content:
      "관련법령에 따라 2017년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 4,
    title: "2018년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2019-04-01",
    password: "",
    filename: "2018 연간기부금모금액_활용실적명세서(창조)",
    file: "2018.pdf",
    content:
      "관련법령에 따라 2018년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 5,
    title: "2019년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2020-03-30",
    password: "",
    filename: "2019 연간기부금모금액_활용실적명세서(창조)",
    file: "2019.pdf",
    content:
      "관련법령에 따라 2019년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 6,
    title: "2020년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2021-03-31",
    password: "",
    filename: "2020 연간기부금모금액_활용실적명세서(창조)",
    file: "2020.pdf",
    content:
      "관련법령에 따라 2020년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
  {
    idx: 7,
    title: "2021년도 연간 기부금 모금액 및 활용 실적",
    createuser: "관리자",
    createat: "2022-05-03",
    password: "",
    filename: "2021 연간기부금모금액_활용실적명세서(창조)",
    file: "2021.pdf",
    content:
      "관련법령에 따라 2021년도 기부금 모금액 활용실적 명세서를 첨부파일로 공개합니다.",
  },
].reverse();

const History = () => {
  return (
    <DonationContainer>
      <h1>기부금 활용실적</h1>
      <div className="SubTitle">
        <span>기부금 활용실적 명세서 공지 게시판</span>
      </div>
      <Board componentName="History" data={HistoryData} />
    </DonationContainer>
  );
};

export default History;
